module.exports = "/images/sala_viajero_pv04.jpg?516e48dc0f182982a1ff9991deb865ef";